import ApiService from "../api.service";
import appConfig from "../../../app-config";
ApiService.init(appConfig.VUE_APP_ROOT_API);

const BankAccountTransactionServices = {
  async saveSundryPayment(payload) {
    const url = `api/Save_SundryPayment`;
    return await ApiService.post(url, payload);
  },
  async cancelBankReconciliation(payload) {
    const url = `api/Save_CancelBankReconciliation`;
    return await ApiService.post(url, payload);
  },
  async saveBankReconciliation(payload) {
    const url = `api/Save_BankReconciliation`;
    return await ApiService.post(url, payload);
  },
  async saveSundryReceipt(payload) {
    const url = `api/Save_SundryReceipt`;
    return await ApiService.post(url, payload);
  },


  async getPaymentMethods() {
    const getPaymentMethods = {
      url: "api/PaymentMethod",
      filter: "Inactive eq 'N'",
      orderby: "PayDesc asc",
    };

    return await ApiService.oDataGet(getPaymentMethods);
  },
}
export { BankAccountTransactionServices };